// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\home\\\\StudioTypesSection\\\\components\\\\Carousel.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\home\\StudioTypesSection\\components\\Carousel.tsx");
  import.meta.hot.lastModified = "1757171103318.746";
}
// REMIX HMR END

import { useRef } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
export function Carousel({
  children,
  showArrows = true,
  className = ""
}) {
  _s();
  const scrollerRef = useRef(null);
  function scrollByCards(dir) {
    const el = scrollerRef.current;
    if (!el) return;
    const card = el.querySelector("[data-card]");
    const amount = card ? card.offsetWidth + 24 : el.clientWidth * 0.9;
    el.scrollBy({
      left: dir === "next" ? amount : -amount,
      behavior: "smooth"
    });
  }
  return <div className={`relative ${className}`}>
      <div ref={scrollerRef} className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Carousel items">
        {children}
      </div>

      {showArrows && <>
          {/* Desktop arrows */}
          <div className="hidden lg:flex absolute -top-[120px] right-0 items-center gap-4">
            <button className="w-[60px] h-[60px] rounded-full border border-neutral-900 opacity-50 flex items-center justify-center transition-opacity hover:opacity-100 !text-black" aria-label="Previous" onClick={() => scrollByCards("prev")}>
              <ArrowLeft className="h-5 w-5" />
            </button>
            <button className="w-[60px] h-[60px] rounded-full border border-neutral-900 flex items-center justify-center transition-opacity hover:opacity-75 !text-black" aria-label="Next" onClick={() => scrollByCards("next")}>
              <ArrowRight className="h-5 w-5" />
            </button>
          </div>

          {/* Mobile arrows */}
          <div className="lg:hidden mt-4 flex justify-end items-center gap-3">
            <button className="w-10 h-10 rounded-full border border-neutral-900 opacity-50 flex items-center justify-center transition-opacity hover:opacity-100" aria-label="Previous" onClick={() => scrollByCards("prev")}>
              <ArrowLeft className="h-4 w-4" />
            </button>
            <button className="w-10 h-10 rounded-full border border-neutral-900 flex items-center justify-center transition-opacity hover:opacity-75" aria-label="Next" onClick={() => scrollByCards("next")}>
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </>}
    </div>;
}
_s(Carousel, "Vj1mQ92rMXBGXhT22Koqyz3PHFE=");
_c = Carousel;
var _c;
$RefreshReg$(_c, "Carousel");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;